// Locale ICU à utiliser pour Date/Number en fonction de la langue active de l'app.
export const LOCALE_BY_LANG = {
    fr: 'fr-FR',
    en: 'en-US',
    es: 'es-ES',
};

export function localeFor(lang) {
    return LOCALE_BY_LANG[lang] || LOCALE_BY_LANG.fr;
}

/**
 * Formate une taille de fichier en utilisant les clés tickets.size.{byte,kb,mb}
 * du fichier de traduction Tickets.json (le hook t doit déjà y être lié).
 */
export function formatFileSize(bytes, t) {
    if (!bytes) return '';
    if (bytes < 1024) return `${bytes} ${t('tickets.size.byte')}`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} ${t('tickets.size.kb')}`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} ${t('tickets.size.mb')}`;
}
